export enum PaymentStatus {
  // 付款狀態, 1=>成功, 0=>等待中, -1=>失敗
  SUCCESS = 1,
  PENDING = 0,
  FAIL = -1,
}

export default PaymentStatus
